<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DED" id="_idParaDest-1"><span class="Italic">To everyone still fighting to save us from our greatest mistakes.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?28c6a47a